import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b80d82ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expandable-item" }
const _hoisted_2 = { class: "expand-item" }
const _hoisted_3 = ["checked", "indeterminate", "disabled"]
const _hoisted_4 = ["aria-controls"]
const _hoisted_5 = ["id"]

import { onMounted, onBeforeUnmount, ref, watch } from 'vue'
import { Collapse } from 'bootstrap'
import { DOMUtil } from './DOMUtil';
import ExpandButton from './ExpandButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableItem',
  props: {
  checkbox: Boolean,
  checked: Boolean,
  indeterminate: Boolean,
  checkDisabled: Boolean,
  expanded: Boolean,
},
  emits: ["check", "update:expanded"],
  setup(__props, { emit }) {

const props = __props;





const expandContentRef = ref<HTMLElement>()
const expandedRef = ref(props.expanded)

const contentId = DOMUtil.randomElementId("content")

watch(() => props.expanded, value => {
  if (value != expandedRef.value) {
    toggleExpand()
  }
})

onMounted(() => {
  expandContentRef.value!.addEventListener('show.bs.collapse', onExpand)
  expandContentRef.value!.addEventListener('hide.bs.collapse', onCollapse)
})

onBeforeUnmount(() => {
  expandContentRef.value!.removeEventListener('show.bs.collapse', onExpand)
  expandContentRef.value!.removeEventListener('hide.bs.collapse', onCollapse)
})

function toggleExpand() {
  new Collapse(expandContentRef.value!) // toggles on init
}

function onExpand(e: Event) {
  if (e.target == e.currentTarget) {
    expandedRef.value = true
    emit('update:expanded', true)
  }
}

function onCollapse(e: Event) {
  if (e.target == e.currentTarget) {
    expandedRef.value = false
    emit('update:expanded', false)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ExpandButton, {
        expanded: expandedRef.value,
        "onUpdate:expanded": toggleExpand
      }, null, 8, ["expanded"]),
      (props.checkbox)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "checkbox",
            checked: props.checked,
            indeterminate: props.indeterminate,
            disabled: props.checkDisabled,
            onInput: _cache[0] || (_cache[0] = e => emit('check')),
            class: "form-check-input"
          }, null, 40, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-inline btn-link link-dark",
        "aria-expanded": "false",
        "aria-controls": _unref(contentId),
        onClick: toggleExpand
      }, [
        _renderSlot(_ctx.$slots, "item")
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("div", {
      id: _unref(contentId),
      ref_key: "expandContentRef",
      ref: expandContentRef,
      class: _normalizeClass(["expand-content collapse", { show: props.expanded }])
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 10, _hoisted_5)
  ]))
}
}

})